export enum ProfileFormTypes {
  BASE = 'base',
  PROFILE = 'profile',
  INDIVIDUAL = 'individual',
  ORGANIZATION = 'organization',
  PATIENT = 'patient',
  DOCTOR = 'doctor',
  MED_STAFF = 'med_staff',
  RESEARCHER = 'researcher',
}

export enum FormTypes {
  POST = 'post',
  PROJECT = 'project',
  COMMUNITY = 'community',
  CONTACT_US = 'contact_us',
  SECOND_AUTH_LEVEL = 'second_auth_level',
  SEARCH = 'search',
}

export enum SearchFormTypes {
  MAP_SEARCH_BLOCK = 'map_search_block',
  MAP_GOTO_BLOCK = 'map_goto_block',
}

export enum ContactUsFormTypes {
  CONTACT_US_LOGGED_IN = 'contact_us_logged_in',
}
